import React from "react";
import { Link } from "react-router-dom";

export const BlogsComp = ({ data }) => {

    return (
        <div id="blogs-comp">
            <div className="text-center">
                <div className="section-title">
                    <h2>Latest Insights & Trends</h2>
                </div>
            </div>
            <div id="blogs-section">
                <div className="blogs">
                    <div className="row">
                        {data && data.length > 0 ? (
                            data.slice(0, 3).map((blog, index) => (
                                <div key={index} className="col-lg-4 col-md-6 mb-4 card">
                                    <div className="card-header">
                                        <Link to={blog.link}>
                                            <img src={blog.image} className="img-fluid" alt="Blog thumbnail" />
                                        </Link>
                                    </div>
                                    <div className="card-body">
                                        <div className="card-title">
                                            <Link to={blog.link}>{blog.title}</Link>
                                        </div>
                                        <div className="card-description">
                                            <p>{blog.excerpt}</p>
                                        </div>
                                        <div className="author">
                                            <img src={blog.authorImage} alt="Author" className="avatar shadow" />
                                            <div className="author-name">
                                                <span>{blog.author}</span>
                                                <div className="author-stats">
                                                    <small>Posted on {blog.date}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center">No blogs available.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};